import React, { ReactElement } from 'react';

import { ContentType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { RenderMarkdownMarked } from 'components/Atoms/RenderMarkdownMarked/RenderMarkdownMarked';
import { ContentContainer } from 'components/Content/Atoms/ContentContainer';
import styles from './TextContent.module.scss';

interface Props {
  content: ContentType;
  alignLeft?: boolean;
}

export function TextContent(props: Props): ReactElement {
  const { content, alignLeft } = props;
  const { translate } = useGetContentTranslations();
  const localizedText = translate(content.translations, 'support_text');

  return (
    <ContentContainer content={content} className={alignLeft ? styles.alignLeft : undefined}>
      <RenderMarkdownMarked text={localizedText} />
    </ContentContainer>
  );
}
